import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "./context/ThemeContext";
import AuthProvider from "./context/AuthContext";
import LoginPage from "./pages/LoginPage";
import PublicAccountRequestPage from "./pages/PublicAccountRequestPage";
import Dashboard from "./pages/Dashboard";
import ProtectedRoute from "./components/ProtectedRoute";
import AdminAddUserPage from "./pages/AdminAddUserPage";
import AdminEditUserPage from "./pages/AdminEditUserPage";
import AdminFilterStudentsPage from "./pages/AdminFilterStudentsPage";
import AdminVeBulkImportPage from "./pages/AdminVeBulkImportPage";
import PmaStudentImportPage from "./pages/PmaStudentImportPage";
import LabCyclePage from "./pages/LabCyclePage";
import LabFleetPage from "./pages/LabFleetPage";
import ServerCapacityPage from "./pages/ServerCapacityPage";
import MasterDropdownPage from "./pages/MasterDropdownPage";
import TrainingCentersPage from "./pages/TrainingCentersPage";
import StudentManagementPage from "./pages/StudentManagementPage";
// New pages for updated schema
import BatchManagementPage from "./pages/BatchManagementPage";
import BatchDetailPage from "./pages/BatchDetailPage";
import InterviewReadinessPage from "./pages/InterviewReadinessPage";
import PlacementManagementPage from "./pages/PlacementManagementPage";
import TrainingConcernsPage from "./pages/TrainingConcernsPage";
import CounsellingSessionsPage from "./pages/CounsellingSessionsPage";
import ReportingDashboardPage from "./pages/ReportingDashboardPage";
import CourseCategoryManagementPage from "./pages/CourseCategoryManagementPage";
import CourseManagementPage from "./pages/CourseManagementPage";
import ModuleManagementPage from "./pages/ModuleManagementPage";
import MockInterviewsPage from "./pages/MockInterviewsPage";
import ModuleCompletionPage from "./pages/ModuleCompletionPage";
import AdminAccessManagementPage from "./pages/AdminAccessManagementPage";
import AdminCreationRequestsPage from "./pages/AdminCreationRequestsPage";
import AdminVeOnboardingPage from "./pages/AdminVeOnboardingPage";
import StudentDashboardPage from "./pages/StudentDashboardPage";
import StudentNotificationsPage from "./pages/StudentNotificationsPage";
import AdminNotificationsPage from "./pages/AdminNotificationsPage";
import AdminFeatureFlagsPage from "./pages/AdminFeatureFlagsPage";
import AdminDatabaseBackupsPage from "./pages/AdminDatabaseBackupsPage";
import AdminDataStagingReviewPage from "./pages/AdminDataStagingReviewPage";
import AdminStudentProfileCompletenessPage from "./pages/AdminStudentProfileCompletenessPage";
import "./styles/theme.css";
import "./styles/theme-specific.css";

function App() {
  return (
    <AuthProvider>
      <ThemeProvider>
        <BrowserRouter>
          <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/request-account" element={<PublicAccountRequestPage />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/student/dashboard"
          element={
            <ProtectedRoute>
              <StudentDashboardPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/student/notifications"
          element={
            <ProtectedRoute>
              <StudentNotificationsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/add-user"
          element={
            <ProtectedRoute>
              <AdminAddUserPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/edit-user"
          element={
            <ProtectedRoute>
              <AdminEditUserPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/filter-students"
          element={
            <ProtectedRoute>
              <AdminFilterStudentsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/student-profile-completeness"
          element={
            <ProtectedRoute>
              <AdminStudentProfileCompletenessPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/masters"
          element={
            <ProtectedRoute>
              <MasterDropdownPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/training-centers"
          element={
            <ProtectedRoute>
              <TrainingCentersPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/ve-import"
          element={
            <ProtectedRoute>
              <AdminVeBulkImportPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/pma-student-import"
          element={
            <ProtectedRoute>
              <PmaStudentImportPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/lab-cycle"
          element={
            <ProtectedRoute>
              <LabCyclePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/lab-fleet"
          element={
            <ProtectedRoute>
              <LabFleetPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/server-capacity"
          element={
            <ProtectedRoute>
              <ServerCapacityPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/data-staging-review"
          element={
            <ProtectedRoute>
              <AdminDataStagingReviewPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/student-management"
          element={
            <ProtectedRoute>
              <StudentManagementPage />
            </ProtectedRoute>
          }
        />
        {/* New routes for updated schema */}
        <Route
          path="/admin/batches"
          element={
            <ProtectedRoute>
              <BatchManagementPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/batches/:id"
          element={
            <ProtectedRoute>
              <BatchDetailPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/interview-readiness"
          element={
            <ProtectedRoute>
              <InterviewReadinessPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/placements"
          element={
            <ProtectedRoute>
              <PlacementManagementPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/training-concerns"
          element={
            <ProtectedRoute>
              <TrainingConcernsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/counselling"
          element={
            <ProtectedRoute>
              <CounsellingSessionsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/reporting"
          element={
            <ProtectedRoute>
              <ReportingDashboardPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/course-categories"
          element={
            <ProtectedRoute>
              <CourseCategoryManagementPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/courses"
          element={
            <ProtectedRoute>
              <CourseManagementPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/modules"
          element={
            <ProtectedRoute>
              <ModuleManagementPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/mock-interviews"
          element={
            <ProtectedRoute>
              <MockInterviewsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/module-completion"
          element={
            <ProtectedRoute>
              <ModuleCompletionPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/access-management"
          element={
            <ProtectedRoute>
              <AdminAccessManagementPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/onboarding"
          element={
            <ProtectedRoute>
              <AdminVeOnboardingPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/creation-requests"
          element={
            <ProtectedRoute>
              <AdminCreationRequestsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/notifications"
          element={
            <ProtectedRoute>
              <AdminNotificationsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/feature-flags"
          element={
            <ProtectedRoute>
              <AdminFeatureFlagsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/database-backups"
          element={
            <ProtectedRoute>
              <AdminDatabaseBackupsPage />
            </ProtectedRoute>
          }
        />
          </Routes>
        </BrowserRouter>
      </ThemeProvider>
    </AuthProvider>
  );
}

export default App;
